import React from 'react';

export default function CustomerLogo() {
  return <div className="homepage__customer-logo" />;
}
